import { Typography } from "@mui/material";
import { TFunction } from "i18next";
import { BookingRequestsStatus } from "../../../BookingRequest/typings/booking-requests.types";
import { serviceLineStatusDisplayOption } from "./OrderRequestCardItem.partial";

/** MRT read-only status column — label for {@link serviceLineStatusDisplayOption}. */
export function renderServiceLineStatusLabelCell(
  status: BookingRequestsStatus | undefined,
  translate: TFunction
) {
  return (
    <Typography component="span" variant="body2">
      {serviceLineStatusDisplayOption(status, translate)?.label ?? ""}
    </Typography>
  );
}
